module.exports = __webpack_public_path__ + "img/2Y.60c97dc3.jpg";